import type { LogisticsContent } from '../../types';
import meetingRoomImage from '../../../assets/images/Two Bear Capital AGM Meeting Room.png';
import walkingDirectionsImage from '../../../assets/images/dinner-walking-directions.png';
import casaTuaImage from '../../../assets/images/casa-tua.png';

export const logistics: LogisticsContent = {
  intro:
    'Everything you need to know about getting to and attending the AGM in Miami',
  attire: 'Business casual attire recommended',
  wifi: { network: 'Whotels_CONFERENCE', password: 'Wsobe25' },
  venue: {
    name: 'W South Beach',
    addressLines: ['2201 Collins Ave', 'Miami Beach, FL 33139'],
    note: 'The meeting will be held in Great Room 1 & 2, accessible from the main lobby.',
    mapQuery: 'W South Beach, 2201 Collins Ave, Miami Beach, FL 33139',
    image: meetingRoomImage,
  },
  dinner: {
    name: 'Casa Tua',
    addressLines: ['1700 James Ave', 'Miami Beach, FL 33139'],
    note: 'Join us for dinner at Casa Tua, a short walk from the W South Beach. If you prefer to drive, valet parking will be covered - simply let the Casa Tua valet know you are with Two Bear Capital.',
    mapQuery: 'Casa Tua, 1700 James Ave, Miami Beach, FL 33139',
    images: [walkingDirectionsImage, casaTuaImage],
  },
  hotels: [
    {
      name: 'W South Beach',
      description: 'Event venue hotel',
      rate: '$549/night',
      bookingUrl:
        'https://www.marriott.com/event-reservations/reservation-link.mi?id=1743546926665&key=GRP&guestreslink2=true&app=resvlink',
    },
  ],
  transportation: [
    {
      icon: 'plane',
      title: 'By Air',
      lines: [
        'Miami International Airport (MIA) - 12 miles from venue',
        'Taxi: ~$35-45 • Uber/Lyft: ~$25-35',
      ],
    },
    {
      icon: 'car',
      title: 'Parking',
      lines: [
        'Valet parking available at W South Beach',
        '$55/day • Self-parking also available nearby',
      ],
    },
    {
      icon: 'transit',
      title: 'Local Transportation',
      lines: [
        'The venue is accessible via Uber/Lyft and taxi services. Miami Beach is very walkable for nearby attractions.',
      ],
    },
  ],
  restaurants: [
    {
      name: 'Mila Miami',
      cuisine: 'MediterrAsian cuisine • Rooftop',
      description: 'Japanese and Mediterranean culinary traditions',
      address: '1636 Meridian Ave, Miami Beach • (786) 673-8374',
      reservationUrl: 'https://mila-miami.com/reserve',
    },
    {
      name: 'The Drexel',
      cuisine: 'Coastal Mediterranean',
      description: 'Serving breakfast and dinner',
      address: '1436 Drexel Ave, Miami Beach • (786) 685-4172',
      reservationUrl:
        'https://www.opentable.com/r/the-drexel-miami-beach?corrid=2cac76c8-e6e1-4208-bad2-7cb358ba303f&avt=eyJ2IjoyLCJtIjowLCJwIjowLCJzIjowLCJuIjowfQ&p=2&sd=2025-01-23T19%3A00%3A00',
    },
    {
      name: 'Aguasal',
      cuisine: 'José Andrés Group',
      description: 'A seaside celebration of bold coastal flavors',
      address: '4041 Collins Ave, Miami Beach • (786) 605-4053',
      reservationUrl:
        'https://www.sevenrooms.com/reservations/aguasalamb/offers-dir',
    },
    {
      name: 'Forte dei Marmi',
      cuisine: 'Italian Fine Dining',
      description: 'Two Michelin Star Chef specializing in slow food culture',
      address: '150 Ocean Drive, Miami Beach • (786) 276-3095',
      reservationUrl: 'https://fdmmiami.com/reserve/',
    },
    {
      name: 'Stubborn Seed',
      cuisine: 'Contemporary American • Michelin One Star',
      description:
        "Chef Jeremy Ford's award-winning restaurant with Latin and Asian influences",
      address: '101 Washington Ave, Miami Beach • (786) 322-5211',
      reservationUrl: 'https://www.stubbornseed.com/reservations',
    },
    {
      name: 'Watr at the Rooftop',
      cuisine: 'Japanese-influenced • Rooftop',
      description:
        '18th floor dining with stunning ocean views and locally-sourced ingredients',
      address: '2341 Collins Ave, Miami Beach • (305) 604-1000',
      reservationUrl:
        'https://www.sevenrooms.com/explore/watrmiamibeach/reservations/create/search?venues=watrmiamibeach%2Chabitat%2Cbeachclubmiami',
    },
  ],
};
